<template>
  <svg
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.9987 2.66665C5.05318 2.66665 2.66536 5.05446 2.66536 7.99998C2.66536 10.9455 5.05318 13.3333 7.9987 13.3333C10.9442 13.3333 13.332 10.9455 13.332 7.99998C13.332 5.05446 10.9442 2.66665 7.9987 2.66665ZM1.33203 7.99998C1.33203 4.31808 4.3168 1.33331 7.9987 1.33331C11.6806 1.33331 14.6654 4.31808 14.6654 7.99998C14.6654 11.6819 11.6806 14.6666 7.9987 14.6666C4.3168 14.6666 1.33203 11.6819 1.33203 7.99998ZM7.9987 5.33331C8.36689 5.33331 8.66536 5.63179 8.66536 5.99998V7.33331H9.9987C10.3669 7.33331 10.6654 7.63179 10.6654 7.99998C10.6654 8.36817 10.3669 8.66665 9.9987 8.66665H8.66536V9.99998C8.66536 10.3682 8.36689 10.6666 7.9987 10.6666C7.63051 10.6666 7.33203 10.3682 7.33203 9.99998V8.66665H5.9987C5.63051 8.66665 5.33203 8.36817 5.33203 7.99998C5.33203 7.63179 5.63051 7.33331 5.9987 7.33331H7.33203V5.99998C7.33203 5.63179 7.63051 5.33331 7.9987 5.33331Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
